"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/ordermade/v1/ems_service.proto (package spwn.ordermade.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMSOrdermadeService = void 0;
const ems_service_pb_1 = require("./ems_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.ordermade.v1.EMSOrdermadeService
 */
exports.EMSOrdermadeService = {
    typeName: "spwn.ordermade.v1.EMSOrdermadeService",
    methods: {
        /**
         * OM商品一覧取得
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.GetOrdermadeProducts
         */
        getOrdermadeProducts: {
            name: "GetOrdermadeProducts",
            I: ems_service_pb_1.EMSOrdermadeServiceGetOrdermadeProductsRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceGetOrdermadeProductsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * OM商品詳細取得
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.GetOrdermadeProductById
         */
        getOrdermadeProductById: {
            name: "GetOrdermadeProductById",
            I: ems_service_pb_1.EMSOrdermadeServiceGetOrdermadeProductByIdRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceGetOrdermadeProductByIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 複数商品マスタと1枚画像を選択して商品作成を行う
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.QuickCreateOrdermadeProducts
         */
        quickCreateOrdermadeProducts: {
            name: "QuickCreateOrdermadeProducts",
            I: ems_service_pb_1.EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.Idempotent,
        },
        /**
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.UpdateOrdermadeProductDetail
         */
        updateOrdermadeProductDetail: {
            name: "UpdateOrdermadeProductDetail",
            I: ems_service_pb_1.EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 承認済み(approved)商品を予約公開する (approved → scheduled_public)
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.SchedulePublishOrdermadeProduct
         */
        schedulePublishOrdermadeProduct: {
            name: "SchedulePublishOrdermadeProduct",
            I: ems_service_pb_1.EMSOrdermadeServiceSchedulePublishOrdermadeProductRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceSchedulePublishOrdermadeProductResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 承認済み(approved)商品を即時販売開始する (approved → selling)
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.SellOrdermadeProductNow
         */
        sellOrdermadeProductNow: {
            name: "SellOrdermadeProductNow",
            I: ems_service_pb_1.EMSOrdermadeServiceSellOrdermadeProductNowRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceSellOrdermadeProductNowResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * OM商品のデザイン編集（オプション/バリアント/面デザインを作り直す）
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.EditOrdermadeProductDesign
         */
        editOrdermadeProductDesign: {
            name: "EditOrdermadeProductDesign",
            I: ems_service_pb_1.EMSOrdermadeServiceEditOrdermadeProductDesignRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceEditOrdermadeProductDesignResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * OM商品の販売申請（複数商品を一括申請）
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.SubmitOrdermadeProductListingApplications
         */
        submitOrdermadeProductListingApplications: {
            name: "SubmitOrdermadeProductListingApplications",
            I: ems_service_pb_1.EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * OM商品の販売申請を取り下げる（申請者操作）
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.WithdrawOrdermadeProductListingApplication
         */
        withdrawOrdermadeProductListingApplication: {
            name: "WithdrawOrdermadeProductListingApplication",
            I: ems_service_pb_1.EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * OM商品の販売申請を承認/却下（マネージャー操作・複数商品対応）
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.ReviewOrdermadeProductListingApplications
         */
        reviewOrdermadeProductListingApplications: {
            name: "ReviewOrdermadeProductListingApplications",
            I: ems_service_pb_1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * OM商品販売申請詳細取得
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.GetOrdermadeProductListingApplicationById
         */
        getOrdermadeProductListingApplicationById: {
            name: "GetOrdermadeProductListingApplicationById",
            I: ems_service_pb_1.EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * OM商品の申請中(submitted)一覧取得（申請日昇順・ページネーション）
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.GetSubmittedOrdermadeProductListingApplications
         */
        getSubmittedOrdermadeProductListingApplications: {
            name: "GetSubmittedOrdermadeProductListingApplications",
            I: ems_service_pb_1.EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * ブランド画像アップロード用Signed URL取得
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.GetSignedUrlForBrandImageUpload
         */
        getSignedUrlForBrandImageUpload: {
            name: "GetSignedUrlForBrandImageUpload",
            I: ems_service_pb_1.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 商品マスタ一覧取得
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.GetFactoryBaseItems
         */
        getFactoryBaseItems: {
            name: "GetFactoryBaseItems",
            I: ems_service_pb_1.EMSOrdermadeServiceGetFactoryBaseItemsRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceGetFactoryBaseItemsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * ショップ開設申請送信
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.SubmitBrandApplication
         */
        submitBrandApplication: {
            name: "SubmitBrandApplication",
            I: ems_service_pb_1.EMSOrdermadeServiceSubmitBrandApplicationRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceSubmitBrandApplicationResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 自分の申請中ショップ一覧取得
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.GetMyPendingBrandApplications
         */
        getMyPendingBrandApplications: {
            name: "GetMyPendingBrandApplications",
            I: ems_service_pb_1.EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 販売元追加申請一覧取得（pending限定、tenant_admin専用）
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.GetBrandApplications
         */
        getBrandApplications: {
            name: "GetBrandApplications",
            I: ems_service_pb_1.EMSOrdermadeServiceGetBrandApplicationsRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceGetBrandApplicationsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 販売元追加申請詳細取得（Admin用）
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.GetBrandApplicationById
         */
        getBrandApplicationById: {
            name: "GetBrandApplicationById",
            I: ems_service_pb_1.EMSOrdermadeServiceGetBrandApplicationByIdRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceGetBrandApplicationByIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 販売元追加申請の承認
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.ApproveBrandApplication
         */
        approveBrandApplication: {
            name: "ApproveBrandApplication",
            I: ems_service_pb_1.EMSOrdermadeServiceApproveBrandApplicationRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceApproveBrandApplicationResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 販売元追加申請の却下
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.RejectBrandApplication
         */
        rejectBrandApplication: {
            name: "RejectBrandApplication",
            I: ems_service_pb_1.EMSOrdermadeServiceRejectBrandApplicationRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceRejectBrandApplicationResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * ショップ公開（Shopify Online Storeにpublish + brand.publishStatus更新）
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.PublishBrand
         */
        publishBrand: {
            name: "PublishBrand",
            I: ems_service_pb_1.EMSOrdermadeServicePublishBrandRequest,
            O: ems_service_pb_1.EMSOrdermadeServicePublishBrandResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.Idempotent,
        },
        /**
         * ショップ非公開（Shopify Online Storeからunpublish + brand.publishStatus更新）
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.UnpublishBrand
         */
        unpublishBrand: {
            name: "UnpublishBrand",
            I: ems_service_pb_1.EMSOrdermadeServiceUnpublishBrandRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceUnpublishBrandResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.Idempotent,
        },
        /**
         * タレントプロフィール検索（外部API経由）
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.SearchTalentProfiles
         */
        searchTalentProfiles: {
            name: "SearchTalentProfiles",
            I: ems_service_pb_1.EMSOrdermadeServiceSearchTalentProfilesRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceSearchTalentProfilesResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * ショップ内アクションの権限取得
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.GetPermissionLevel
         */
        getPermissionLevel: {
            name: "GetPermissionLevel",
            I: ems_service_pb_1.EMSOrdermadeServiceGetPermissionLevelRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceGetPermissionLevelResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * ショップ作成可否取得
         *
         * @generated from rpc spwn.ordermade.v1.EMSOrdermadeService.GetCanCreateShop
         */
        getCanCreateShop: {
            name: "GetCanCreateShop",
            I: ems_service_pb_1.EMSOrdermadeServiceGetCanCreateShopRequest,
            O: ems_service_pb_1.EMSOrdermadeServiceGetCanCreateShopResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=ems_service_connect.js.map